module.exports = __webpack_public_path__ + "img/twitter.32d7d7d7.svg";